import * as genericUtils from '@tolk-ai/generic-utils';
import * as browserUtils from '@tolk-ai/browser-utils';

const convertDateToFormattedDate = date => {
  const year = `${date.getFullYear()}`;
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  return `${year}-${month}-${day}`;
};

const getOneChannelDetailConversationsCountRequest = botManagementAxios => async (startDate, endDate, channelId) => {
  try {
    const searchParameters = new URLSearchParams();
    searchParameters.append('startDate', convertDateToFormattedDate(startDate));
    searchParameters.append('endDate', convertDateToFormattedDate(endDate));
    return (await botManagementAxios.get(`/v1/channels/${channelId}/detail-conversation-count?${searchParameters.toString()}`)).data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertRestDayConversationCountToDayConversationCount = restDayConversationCount => ({
  count: restDayConversationCount.count,
  date: new Date(restDayConversationCount.date)
});

const convertRestChannelDetailConversationCountToChannelDetailConversationCount = restChannelDetailConversationCount => ({
  channelId: restChannelDetailConversationCount.channelId,
  detailCount: restChannelDetailConversationCount.detailCount.map(restDayConversationCount => convertRestDayConversationCountToDayConversationCount(restDayConversationCount)),
  endDate: new Date(restChannelDetailConversationCount.endDate),
  startDate: new Date(restChannelDetailConversationCount.startDate),
  totalCount: restChannelDetailConversationCount.totalCount
});

const getOneChannelDetailConversationsCount$1 = botManagementAxios => async (startDate, endDate, channelId) => {
  const result = await getOneChannelDetailConversationsCountRequest(botManagementAxios)(startDate, endDate, channelId);
  return convertRestChannelDetailConversationCountToChannelDetailConversationCount(result);
};

var index$b = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneChannelDetailConversationsCount: getOneChannelDetailConversationsCount$1
});

const getOneSubscriptionStripe = axios => async billingId => {
  try {
    const result = await axios.get(`/v1/customers/${billingId}/subscriptions`);
    return result.data;
  } catch (_a) {
    return null;
  }
};

const filterSubscriptionStripeMetered = subscriptionStripe => subscriptionStripe.items.data.filter(item => {
  return item.price.recurring.usage_type === 'metered';
});

const convertRestSubscriptionStripeToItemSubscriptionMetered = (restSubscriptionStripe, billingId) => {
  const subscriptionItemsMetered = restSubscriptionStripe.data.map(subscriptionStripe => filterSubscriptionStripeMetered(subscriptionStripe));
  const itemSubscriptionArray = subscriptionItemsMetered.flat();
  return genericUtils.isEmpty(itemSubscriptionArray) ? null : {
    billingId,
    itemSubscriptionId: itemSubscriptionArray[genericUtils.ARRAY.FIRST_INDEX].id
  };
};

const getOneItemSubscriptionMeteredByBillingInfo = axios => async billingInfos => {
  const restSubscriptionStripe = await getOneSubscriptionStripe(axios)(billingInfos.billingId);

  if (restSubscriptionStripe === null) {
    return null;
  }

  return convertRestSubscriptionStripeToItemSubscriptionMetered(restSubscriptionStripe, billingInfos.billingId);
};

var index$a = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneItemSubscriptionMeteredByBillingInfo: getOneItemSubscriptionMeteredByBillingInfo
});

const getBotByBotIdAxios = axios => async botId => {
  try {
    const result = await axios.get(`/v1/bots/${botId}`);
    return result.data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.status === genericUtils.HTTP_CODE.NOT_FOUND) {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestBotToBot = restBot => ({
  clientId: restBot.clientId,
  id: restBot.id
});

const getBotByBotId = axios => async botId => {
  const result = await getBotByBotIdAxios(axios)(botId);

  if (result === null) {
    return null;
  }

  return convertRestBotToBot(result);
};

var index$9 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getBotByBotId: getBotByBotId
});

const getManyMongoChannelByChannelIds = mongodb => async channels => {
  try {
    return await mongodb.collection('api_channels').find({
      _id: {
        $in: [...channels]
      }
    }, {
      projection: {
        _id: 1,
        bot_id: 1
      }
    }).toArray();
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyMongoChannelByBotIds = mongodb => async botIds => {
  try {
    return await mongodb.collection('api_channels').find({
      bot_id: {
        $in: [...botIds]
      }
    }, {
      projection: {
        _id: 1,
        bot_id: 1
      }
    }).toArray();
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyMongoChannelsByBotId$1 = mongodb => async botId => {
  try {
    return await mongodb.collection('api_channels').find({
      bot_id: botId
    }, {
      projection: {
        _id: 1,
        bot_id: 1
      }
    }).toArray();
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertMongoChannelToChannel = mongoChannel => ({
  botId: mongoChannel.bot_id,
  // eslint-disable-next-line no-underscore-dangle
  id: mongoChannel._id
});

const getManyChannelByChannelIds = mongodb => async channelsId => {
  const result = await getManyMongoChannelByChannelIds(mongodb)(channelsId);
  return result.map(mongoChannel => convertMongoChannelToChannel(mongoChannel));
};

const getManyChannelByBotsIds = mongodb => async botIds => {
  const result = await getManyMongoChannelByBotIds(mongodb)(botIds);
  return result.map(mongoChannel => convertMongoChannelToChannel(mongoChannel));
};

const getManyChannelsByBotId = mongodb => async botId => {
  const result = await getManyMongoChannelsByBotId$1(mongodb)(botId);
  return result.map(mongoChannel => convertMongoChannelToChannel(mongoChannel));
};

var index$8 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getManyChannelByBotsIds: getManyChannelByBotsIds,
  getManyChannelByChannelIds: getManyChannelByChannelIds,
  getManyChannelsByBotId: getManyChannelsByBotId
});

const getOneBillingInfosByClientId$1 = axios => async clientId => {
  try {
    const result = await axios.get(`/v1/clients/${clientId}/billings-infos`);
    return result.data;
  } catch (_a) {
    return null;
  }
};

const getOneClientBotsByClientId$1 = axios => async clientId => {
  try {
    const result = await axios.get(`/v1/clients/${clientId}/bots`);
    return result.data;
  } catch (_a) {
    return null;
  }
};

const getAllClientBots$1 = axios => async () => {
  try {
    const result = await axios.get(`/v1/clients-bots`);
    return result.data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertRestBillingInfosToBillingInfos = restBillingInfos => ({
  billingId: restBillingInfos.billingId,
  clientId: restBillingInfos.clientId,
  portalUrl: restBillingInfos.portalUrl
});

const convertRestClientBotToClientBot = restClientBots => ({
  bots: restClientBots.bots,
  clientId: restClientBots.clientId
});

const getOneBillingInfosByClientId = axios => async clientId => {
  const result = await getOneBillingInfosByClientId$1(axios)(clientId);

  if (result === null) {
    return null;
  }

  return convertRestBillingInfosToBillingInfos(result);
};

const getOneClientBotsByClientId = axios => async clientId => {
  const restClientBot = await getOneClientBotsByClientId$1(axios)(clientId);

  if (restClientBot === null) {
    return null;
  }

  return convertRestClientBotToClientBot(restClientBot);
};

const getAllClientBots = axios => async () => {
  const restManyClientBots = await getAllClientBots$1(axios)();
  return restManyClientBots.map(restClientBots => convertRestClientBotToClientBot(restClientBots));
};

var index$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAllClientBots: getAllClientBots,
  getOneBillingInfosByClientId: getOneBillingInfosByClientId,
  getOneClientBotsByClientId: getOneClientBotsByClientId
});

const getManyPgBotConversationsCountByPeriodAndManyBotId = pool => async (startDate, endDate, botIds) => {
  try {
    if (genericUtils.isEmpty(botIds)) {
      return [];
    }

    const offset = 3;
    const botIdParameters = botIds.map((botId, index) => {
      return `$${index + offset}`;
    }).join(',');
    const result = await pool.query(`
        SELECT COUNT(id) as nb, bot_id
        FROM conversation_event
        WHERE name= 'conversation-created'
          AND conversation_event.date BETWEEN $1 AND $2
          AND bot_id IN(${botIdParameters})
        GROUP BY bot_id
        ORDER BY nb ASC
       `, [startDate, endDate, ...botIds]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgChannelConversationsCountByPeriod = pool => async (startDate, endDate) => {
  try {
    const result = await pool.query(`SELECT COUNT(id) as nb,
            bot_id,
            channel_id
          FROM conversation_event
          WHERE name= 'conversation-created'
              AND conversation_event.date BETWEEN $1 AND $2
          GROUP BY channel_id, bot_id`, [startDate, endDate]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertPgBotConversationCountToBotConversationCount = (pgBotConversationCount, startDate, endDate) => ({
  botId: pgBotConversationCount.bot_id,
  count: Number(pgBotConversationCount.nb),
  endDate,
  startDate
});

const convertPgChannelConversationCountToChannelConversationCount = pgChannelConversationCount => ({
  botId: pgChannelConversationCount.bot_id,
  count: Number(pgChannelConversationCount.nb),
  id: pgChannelConversationCount.channel_id
});

const getBotIdsFromClientsBots = clientsBots => clientsBots.reduce((accumulator, currentValue) => {
  return [...accumulator, ...currentValue.bots.filter(botId => !accumulator.includes(botId))];
}, []);

const combineClientBotsAndBotConversationCountToConversationCount = (clientsBots, botsConversationsCount, startDate, endDate) => clientsBots.map(clientBots => {
  const counts = clientBots.bots.map(botId => {
    var _a;

    const botConversationFound = botsConversationsCount.find(botConversationsCount => botConversationsCount.botId === botId);
    return (_a = botConversationFound === null || botConversationFound === void 0 ? void 0 : botConversationFound.count) !== null && _a !== void 0 ? _a : genericUtils.NUMBER.ZERO;
  });
  return {
    clientId: clientBots.clientId,
    count: counts.reduce((accumulator, value) => accumulator + value, genericUtils.NUMBER.ZERO),
    endDate,
    startDate
  };
});

const getManyBotConversationCountByPeriod = pool => async (startDate, endDate, botIds) => {
  const pgBotsConversationCount = await getManyPgBotConversationsCountByPeriodAndManyBotId(pool)(startDate.toISOString(), endDate.toISOString(), botIds);
  return pgBotsConversationCount.map(pgBotConversationCount => convertPgBotConversationCountToBotConversationCount(pgBotConversationCount, startDate, endDate));
};

const getManyConversationCountByPeriodAndClientsBots = pool => async (startDate, endDate, clientsBots) => {
  const botIds = getBotIdsFromClientsBots(clientsBots);
  const pgBotsConversationCount = await getManyPgBotConversationsCountByPeriodAndManyBotId(pool)(startDate.toISOString(), endDate.toISOString(), botIds);
  const botConversationsCount = pgBotsConversationCount.map(pgBotConversationCount => convertPgBotConversationCountToBotConversationCount(pgBotConversationCount, startDate, endDate));
  return combineClientBotsAndBotConversationCountToConversationCount(clientsBots, botConversationsCount, startDate, endDate);
};

const getManyConversationsByPeriod = poolAnalytic => async (startDate, endDate) => {
  const pgChannelsConversationCount = await getManyPgChannelConversationsCountByPeriod(poolAnalytic)(startDate.toISOString(), endDate.toISOString());
  return pgChannelsConversationCount.map(pgChannelConversationCount => convertPgChannelConversationCountToChannelConversationCount(pgChannelConversationCount));
};

var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getManyBotConversationCountByPeriod: getManyBotConversationCountByPeriod,
  getManyConversationCountByPeriodAndClientsBots: getManyConversationCountByPeriodAndClientsBots,
  getManyConversationsByPeriod: getManyConversationsByPeriod
});

const getManyPgConversationsByManyChannelIdAndPeriod = pool => async (startDate, endDate, channelIds) => {
  try {
    if (genericUtils.isEmpty(channelIds)) {
      return [];
    }

    const offset = 3;
    const channelParameters = channelIds.map((channel, index) => {
      return `$${index + offset}`;
    }).join(',');
    const result = await pool.query(`
        SELECT
            conversation_id,
            user_id,
            channel_id,
            active_interlocutor,
            creation_date
        FROM conversation
        WHERE channel_id IN(${channelParameters})
        AND creation_date >= $1
        AND creation_date <= $2`, [startDate, endDate, ...channelIds]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertPgConversationToConversation = pgConversation => ({
  activeInterlocutor: pgConversation.active_interlocutor,
  channelId: pgConversation.channel_id,
  creationDate: new Date(pgConversation.creation_date),
  id: pgConversation.conversation_id,
  userId: pgConversation.user_id
});

const formatDataPostUsageRecords = (quantity, date) => {
  const data = new URLSearchParams();
  data.append('quantity', quantity.toString());
  data.append('action', 'increment');
  data.append('timestamp', Math.floor(date.getTime() / genericUtils.TIME.MILLISECONDS_IN_A_SECOND).toString());
  return data;
};

const sendUsageRecordStripe = axios => async (clientStripeConversationsCount, date) => {
  try {
    await axios.post(`/v1/subscription_items/${clientStripeConversationsCount.itemSubscriptionMeteredId}/usage_records`, formatDataPostUsageRecords(clientStripeConversationsCount.count, date));
    return true;
  } catch (_a) {
    return false;
  }
};

const insertPgUsageRecord = pool => async usageRecord => {
  try {
    await pool.query(`INSERT INTO usage_record(
        usage_record_id,
        bot_id,
        channel_id,
        nb_record,
        client_id,
        type,
        create_date,
        status
      )
      VALUES (
        $1,
        $2,
        $3,
        $4,
        $5,
        $6,
        $7,
        $8
      );`, [usageRecord.id, usageRecord.botId, usageRecord.channelId, usageRecord.nbRecord, usageRecord.clientId, usageRecord.type, usageRecord.date, usageRecord.status]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgDayConversationCount = pool => async (startDate, endDate, channelId) => {
  try {
    return (await pool.query(`
      SELECT to_char(series.creation_date,'yyyy-mm-dd') AS creation_date,
      count(convseries.id)
      FROM  (
        SELECT generate_series(min($1)::date
                        , max($2)::date
                        , interval '1 day'
          )::date AS creation_date
        FROM conversation
      ) series
      LEFT JOIN conversation convseries
      ON convseries.creation_date::date = series.creation_date
      AND convseries.channel_id = $3
      GROUP BY 1
      ORDER BY 1;`, [startDate, endDate, channelId])).rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertManyPgDayConversationCountToManyDaysConversationCount = pgManyDaysConversationCount => pgManyDaysConversationCount.map(pgOneDayConversationCount => ({
  count: Number.parseInt(pgOneDayConversationCount.count, 10),
  date: new Date(pgOneDayConversationCount.creation_date)
}));

const getManyConversationsByManyChannelIdAndPeriod = poolBot => async (startDate, endDate, channelIds) => {
  const allPgConversations = await getManyPgConversationsByManyChannelIdAndPeriod(poolBot)(startDate.toISOString(), endDate.toISOString(), channelIds);
  return allPgConversations.map(pgConversation => convertPgConversationToConversation(pgConversation));
};

const sendOneConversationsCountStripe = (axiosStripe, pool, usageRecordFactory) => async (clientBotChannelBillingItemSubscriptionConversationsCount, date) => {
  const result = await sendUsageRecordStripe(axiosStripe)(clientBotChannelBillingItemSubscriptionConversationsCount, date);
  const manyUsageRecord = clientBotChannelBillingItemSubscriptionConversationsCount.details.map(botChannelConversationsCount => usageRecordFactory(botChannelConversationsCount.botId, botChannelConversationsCount.channelId, botChannelConversationsCount.count, clientBotChannelBillingItemSubscriptionConversationsCount.clientId, 'stripe', result ? 'sent' : 'error', date));
  await Promise.all(manyUsageRecord.map(async usageRecord => insertPgUsageRecord(pool)(usageRecord)));
};

const sendOneConversationsCount = (pool, usageRecordFactory) => async (clientBotChannelClient, date) => {
  const usageRecord = usageRecordFactory(clientBotChannelClient.botId, clientBotChannelClient.channelId, clientBotChannelClient.count, clientBotChannelClient.clientId, 'other', 'sent', date);
  await insertPgUsageRecord(pool)(usageRecord);
};

const getManyDaysConversationCount = pool => async (startDate, endDate, channelId) => {
  const result = await getManyPgDayConversationCount(pool)(startDate.toISOString(), endDate.toISOString(), channelId);
  return convertManyPgDayConversationCountToManyDaysConversationCount(result);
};

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getManyConversationsByManyChannelIdAndPeriod: getManyConversationsByManyChannelIdAndPeriod,
  getManyDaysConversationCount: getManyDaysConversationCount,
  sendOneConversationsCount: sendOneConversationsCount,
  sendOneConversationsCountStripe: sendOneConversationsCountStripe
});

const getManyMongoChannelsByBotId = mongodb => async botId => {
  try {
    return await mongodb.collection('api_channels').find({
      bot_id: botId
    }, {
      projection: {
        _id: 1,
        bot_id: 1
      }
    }).toArray();
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgDayConversationCountByManyChannelId = pool => async (startDate, endDate, channelIds) => {
  try {
    if (genericUtils.isEmpty(channelIds)) {
      return (await pool.query(`
        SELECT to_char(series.creation_date,'yyyy-mm-dd') AS creation_date,
        count(convseries.id)
        FROM  (
          SELECT generate_series(min($1)::date
                          , max($2)::date
                          , interval '1 day'
            )::date AS creation_date
          FROM conversation
        ) series
        LEFT JOIN conversation convseries
        ON convseries.creation_date::date = series.creation_date
        AND convseries.id = $3
        GROUP BY 1
        ORDER BY 1;`, [startDate, endDate, null])).rows;
    }

    const offset = 3;
    const channelIdsParameters = channelIds.map((channelId, index) => {
      return `$${index + offset}`;
    }).join(',');
    return (await pool.query(`
      SELECT to_char(series.creation_date,'yyyy-mm-dd') AS creation_date,
      count(convseries.id)
      FROM  (
        SELECT generate_series(min($1)::date
                        , max($2)::date
                        , interval '1 day'
          )::date AS creation_date
        FROM conversation
      ) series
      LEFT JOIN conversation convseries
      ON convseries.creation_date::date = series.creation_date
      AND convseries.channel_id IN (${channelIdsParameters})
      GROUP BY 1
      ORDER BY 1;`, [startDate, endDate, ...channelIds])).rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertManyPgDayConversationCountToManyBotDayConversationCount = pgManyDaysConversationCount => pgManyDaysConversationCount.map(pgOneDayConversationCount => ({
  count: Number.parseInt(pgOneDayConversationCount.count, 10),
  date: new Date(pgOneDayConversationCount.creation_date)
}));

const getManyBotDaysConversationCountByBotId = (mongodb, pool) => async (startDate, endDate, botId) => {
  const manyMongoChannel = await getManyMongoChannelsByBotId(mongodb)(botId); // eslint-disable-next-line no-underscore-dangle

  const channelIds = manyMongoChannel.map(mongoChannel => mongoChannel._id);
  const result = await getManyPgDayConversationCountByManyChannelId(pool)(startDate.toISOString(), endDate.toISOString(), channelIds);
  return convertManyPgDayConversationCountToManyBotDayConversationCount(result);
};

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getManyBotDaysConversationCountByBotId: getManyBotDaysConversationCountByBotId
});

const fifthIndex = 4;
const sixthIndex = 5;

const getOneConversationCountWithCompanyId = axios => async conversationCount => {
  const data = {
    filterGroups: [{
      filters: [{
        operator: 'EQ',
        propertyName: 'tolk_client_id',
        value: conversationCount.clientId
      }]
    }]
  };

  try {
    const result = await axios.post('/crm/v3/objects/companies/search', data);
    return result.data.total > genericUtils.NUMBER.ZERO ? {
      companyId: result.data.results[genericUtils.NUMBER.ZERO].id,
      count: conversationCount.count,
      endDate: conversationCount.endDate,
      startDate: conversationCount.startDate
    } : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getAllConversationCountWithCompanyId = axios => async conversationCounts => {
  const firstItems = conversationCounts.slice(genericUtils.ARRAY.FIRST_INDEX, fifthIndex);
  const results = (await Promise.all(firstItems.map(async conversationCount => {
    return getOneConversationCountWithCompanyId(axios)(conversationCount);
  }))).filter(result => result !== null);
  const nextItems = conversationCounts.slice(sixthIndex, conversationCounts.length);

  if (nextItems.length > genericUtils.ARRAY.EMPTY_LENGTH) {
    await genericUtils.wait(genericUtils.TIME.MILLISECONDS_IN_A_SECOND);
    return [...(await getAllConversationCountWithCompanyId(axios)(nextItems)), ...results];
  }

  return [...results];
};

const getOneCustomData = (axios, customObjectId) => async conversationCountWithCompanyId => {
  const uri = `/crm/v3/objects/${customObjectId}`;
  const data = {
    properties: {
      tolk_daily_kpis_conversations_count_2: conversationCountWithCompanyId.count,
      tolk_daily_kpis_date_2: conversationCountWithCompanyId.startDate
    }
  };

  try {
    const result = await axios.post(uri, data);
    return {
      companyId: conversationCountWithCompanyId.companyId,
      customDataId: result.data.id
    };
  } catch (error) {
    console.log('error', error);
    throw genericUtils.sanitizeError(error);
  }
};

const getAllCustomData = (axios, customObjectId) => async conversationsCountWithCompanyId => {
  const firstItems = conversationsCountWithCompanyId.slice(genericUtils.ARRAY.FIRST_INDEX, fifthIndex);
  const result = await Promise.all(firstItems.map(async conversationCountWithCompanyId => {
    return getOneCustomData(axios, customObjectId)(conversationCountWithCompanyId);
  }));
  const nextItems = conversationsCountWithCompanyId.slice(sixthIndex, conversationsCountWithCompanyId.length);

  if (nextItems.length > genericUtils.ARRAY.EMPTY_LENGTH) {
    await genericUtils.wait(genericUtils.TIME.MILLISECONDS_IN_A_SECOND);
    return [...(await getAllCustomData(axios, customObjectId)(nextItems)), ...result];
  }

  return [...result];
};

const linkOneCustomDataWithCompany = (axios, customObjectId, type) => async customData => {
  try {
    const uri = `/crm/v3/associations/Company/${customObjectId}/batch/create`;
    const data = {
      inputs: [{
        from: {
          id: customData.companyId
        },
        to: {
          id: customData.customDataId
        },
        type
      }]
    };
    await axios.post(uri, data);
  } catch (error) {
    console.log('error link', error);
    throw genericUtils.sanitizeError(error);
  }
};

const linkAllCustomDataWithCompany = (axios, customObjectId, type) => async customDatas => {
  const firstItems = customDatas.slice(genericUtils.ARRAY.FIRST_INDEX, fifthIndex);
  await Promise.all(firstItems.map(async customData => {
    return linkOneCustomDataWithCompany(axios, customObjectId, type)(customData);
  }));
  const nextItems = customDatas.slice(sixthIndex, customDatas.length);

  if (nextItems.length > genericUtils.ARRAY.EMPTY_LENGTH) {
    await genericUtils.wait(genericUtils.TIME.MILLISECONDS_IN_A_SECOND);
    return linkAllCustomDataWithCompany(axios, customObjectId, type)(nextItems);
  }
};

const saveManyConversationCount = (axios, hubspotCustomObjectId, hubspotType) => async conversationsCount => {
  const conversationsCountWithCompanyId = await getAllConversationCountWithCompanyId(axios)(conversationsCount);
  const customDatas = await getAllCustomData(axios, hubspotCustomObjectId)(conversationsCountWithCompanyId);
  await linkAllCustomDataWithCompany(axios, hubspotCustomObjectId, hubspotType)(customDatas);
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  saveManyConversationCount: saveManyConversationCount
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	RestChannelIdRequest: {
		type: "string"
	},
	RestDayConversationCount: {
		type: "object",
		properties: {
			date: {
				type: "string"
			},
			count: {
				type: "number"
			}
		},
		required: [
			"date",
			"count"
		],
		additionalProperties: false
	},
	RestChannelDetailConversationCount: {
		type: "object",
		properties: {
			startDate: {
				type: "string"
			},
			endDate: {
				type: "string"
			},
			channelId: {
				$ref: "#/definitions/RestChannelIdRequest"
			},
			totalCount: {
				type: "number"
			},
			detailCount: {
				type: "array",
				items: {
					$ref: "#/definitions/RestDayConversationCount"
				}
			}
		},
		required: [
			"startDate",
			"endDate",
			"channelId",
			"totalCount",
			"detailCount"
		],
		additionalProperties: false
	},
	ChannelId: {
		type: "string"
	},
	Channel: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/ChannelId"
			},
			botId: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"id",
			"botId"
		],
		additionalProperties: false
	},
	BotId: {
		type: "string"
	},
	DayConversationCount: {
		type: "object",
		properties: {
			date: {
				type: "string",
				format: "date-time"
			},
			count: {
				type: "number"
			}
		},
		required: [
			"date",
			"count"
		],
		additionalProperties: false
	},
	ChannelDetailConversationCount: {
		type: "object",
		properties: {
			startDate: {
				type: "string",
				format: "date-time"
			},
			endDate: {
				type: "string",
				format: "date-time"
			},
			channelId: {
				$ref: "#/definitions/ChannelId"
			},
			totalCount: {
				type: "number"
			},
			detailCount: {
				type: "array",
				items: {
					$ref: "#/definitions/DayConversationCount"
				}
			}
		},
		required: [
			"startDate",
			"endDate",
			"channelId",
			"totalCount",
			"detailCount"
		],
		additionalProperties: false
	},
	ChannelBotConversationCount: {
		type: "object",
		properties: {
			botId: {
				$ref: "#/definitions/BotId"
			},
			id: {
				$ref: "#/definitions/ChannelId"
			},
			count: {
				type: "number"
			}
		},
		required: [
			"botId",
			"id",
			"count"
		],
		additionalProperties: false
	},
	ClientId: {
		type: "string"
	},
	StartDate: {
		type: "string",
		format: "date-time"
	},
	EndDate: {
		type: "string",
		format: "date-time"
	},
	BillingId: {
		type: "string"
	},
	ItemSubscriptionId: {
		type: "string"
	},
	ClientBots: {
		type: "object",
		properties: {
			clientId: {
				type: "string"
			},
			bots: {
				type: "array",
				items: {
					type: "string"
				}
			}
		},
		required: [
			"clientId",
			"bots"
		],
		additionalProperties: false
	},
	ClientsBots: {
		type: "array",
		items: {
			$ref: "#/definitions/ClientBots"
		}
	},
	ConversationCount: {
		type: "object",
		properties: {
			startDate: {
				$ref: "#/definitions/StartDate"
			},
			endDate: {
				$ref: "#/definitions/EndDate"
			},
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			count: {
				type: "number"
			}
		},
		required: [
			"startDate",
			"endDate",
			"clientId",
			"count"
		],
		additionalProperties: false
	},
	Conversation: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			userId: {
				type: "string"
			},
			channelId: {
				$ref: "#/definitions/ChannelId"
			},
			activeInterlocutor: {
				type: "string",
				"enum": [
					"Agent",
					"Bot"
				]
			},
			creationDate: {
				type: "string",
				format: "date-time"
			}
		},
		required: [
			"id",
			"userId",
			"channelId",
			"activeInterlocutor",
			"creationDate"
		],
		additionalProperties: false
	},
	Client: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/ClientId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	BillingInfos: {
		type: "object",
		properties: {
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			portalUrl: {
				type: "string"
			},
			billingId: {
				$ref: "#/definitions/BillingId"
			}
		},
		required: [
			"clientId",
			"portalUrl",
			"billingId"
		],
		additionalProperties: false
	},
	ItemSubscriptionMetered: {
		type: "object",
		properties: {
			billingId: {
				$ref: "#/definitions/BillingId"
			},
			itemSubscriptionId: {
				$ref: "#/definitions/ItemSubscriptionId"
			}
		},
		required: [
			"billingId",
			"itemSubscriptionId"
		],
		additionalProperties: false
	},
	BotChannelConversationsCount: {
		type: "object",
		properties: {
			channelId: {
				$ref: "#/definitions/ChannelId"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			count: {
				type: "number"
			}
		},
		required: [
			"channelId",
			"botId",
			"count"
		],
		additionalProperties: false
	},
	ClientBotChannelConversationsCount: {
		type: "object",
		properties: {
			channelId: {
				$ref: "#/definitions/ChannelId"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			count: {
				type: "number"
			}
		},
		required: [
			"channelId",
			"botId",
			"clientId",
			"count"
		],
		additionalProperties: false
	},
	ClientBotChannelBillingConversationsCount: {
		type: "object",
		properties: {
			channelId: {
				$ref: "#/definitions/ChannelId"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			count: {
				type: "number"
			},
			billingId: {
				$ref: "#/definitions/BillingId"
			}
		},
		required: [
			"channelId",
			"botId",
			"clientId",
			"count",
			"billingId"
		],
		additionalProperties: false
	},
	ClientBotChannelBillingSubscriptionConversationsCount: {
		type: "object",
		properties: {
			channelId: {
				$ref: "#/definitions/ChannelId"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			count: {
				type: "number"
			},
			billingId: {
				$ref: "#/definitions/BillingId"
			},
			itemSubscriptionMeteredId: {
				type: "string"
			}
		},
		required: [
			"channelId",
			"botId",
			"clientId",
			"count",
			"billingId",
			"itemSubscriptionMeteredId"
		],
		additionalProperties: false
	},
	ClientStripeConversationsCount: {
		type: "object",
		properties: {
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			count: {
				type: "number"
			},
			billingId: {
				$ref: "#/definitions/BillingId"
			},
			itemSubscriptionMeteredId: {
				type: "string"
			},
			details: {
				type: "array",
				items: {
					$ref: "#/definitions/BotChannelConversationsCount"
				}
			}
		},
		required: [
			"clientId",
			"count",
			"billingId",
			"itemSubscriptionMeteredId",
			"details"
		],
		additionalProperties: false
	},
	BotUsers: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BotId"
			},
			users: {
				type: "array",
				items: {
					type: "string"
				}
			}
		},
		required: [
			"id",
			"users"
		],
		additionalProperties: false
	},
	Bot: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BotId"
			},
			clientId: {
				anyOf: [
					{
						$ref: "#/definitions/ClientId"
					},
					{
						type: "null"
					}
				]
			}
		},
		required: [
			"id",
			"clientId"
		],
		additionalProperties: false
	},
	BotConversationsCount: {
		type: "object",
		properties: {
			startDate: {
				$ref: "#/definitions/StartDate"
			},
			endDate: {
				$ref: "#/definitions/EndDate"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			count: {
				type: "number"
			}
		},
		required: [
			"startDate",
			"endDate",
			"botId",
			"count"
		],
		additionalProperties: false
	},
	BotDayConversationCount: {
		type: "object",
		properties: {
			date: {
				type: "string",
				format: "date-time"
			},
			count: {
				type: "number"
			}
		},
		required: [
			"date",
			"count"
		],
		additionalProperties: false
	},
	BotDetailConversationCount: {
		type: "object",
		properties: {
			startDate: {
				$ref: "#/definitions/StartDate"
			},
			endDate: {
				$ref: "#/definitions/EndDate"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			totalCount: {
				type: "number"
			},
			detailCount: {
				type: "array",
				items: {
					$ref: "#/definitions/BotDayConversationCount"
				}
			}
		},
		required: [
			"startDate",
			"endDate",
			"botId",
			"totalCount",
			"detailCount"
		],
		additionalProperties: false
	},
	UsageRecordType: {
		type: "string",
		"enum": [
			"stripe",
			"other"
		]
	},
	UsageRecordStatus: {
		type: "string",
		"enum": [
			"error",
			"sent"
		]
	},
	UsageRecord: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			botId: {
				$ref: "#/definitions/BotId"
			},
			channelId: {
				$ref: "#/definitions/ChannelId"
			},
			nbRecord: {
				type: "number"
			},
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			type: {
				$ref: "#/definitions/UsageRecordType"
			},
			date: {
				type: "string",
				format: "date-time"
			},
			status: {
				$ref: "#/definitions/UsageRecordStatus"
			}
		},
		required: [
			"id",
			"botId",
			"channelId",
			"nbRecord",
			"clientId",
			"type",
			"date",
			"status"
		],
		additionalProperties: false
	},
	UserId: {
		type: "string"
	},
	RecurringPrice: {
		type: "object",
		properties: {
			usage_type: {
				type: "string",
				"enum": [
					"licensed",
					"metered"
				]
			}
		},
		required: [
			"usage_type"
		],
		additionalProperties: false
	},
	Price: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			object: {
				type: "string",
				"const": "price"
			},
			active: {
				type: "boolean"
			},
			livemode: {
				type: "boolean"
			},
			recurring: {
				$ref: "#/definitions/RecurringPrice"
			}
		},
		required: [
			"id",
			"object",
			"active",
			"livemode",
			"recurring"
		],
		additionalProperties: false
	},
	ItemSubscription: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			object: {
				type: "string",
				"const": "subscription_item"
			},
			price: {
				$ref: "#/definitions/Price"
			}
		},
		required: [
			"id",
			"object",
			"price"
		],
		additionalProperties: false
	},
	ItemSubscriptionList: {
		type: "object",
		properties: {
			object: {
				type: "string",
				"const": "list"
			},
			data: {
				type: "array",
				items: {
					$ref: "#/definitions/ItemSubscription"
				}
			}
		},
		required: [
			"object",
			"data"
		],
		additionalProperties: false
	},
	SubscriptionStripe: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			object: {
				type: "string",
				"const": "subscription"
			},
			items: {
				$ref: "#/definitions/ItemSubscriptionList"
			}
		},
		required: [
			"id",
			"object",
			"items"
		],
		additionalProperties: false
	},
	RestSubscriptionStripe: {
		type: "object",
		properties: {
			data: {
				type: "array",
				items: {
					$ref: "#/definitions/SubscriptionStripe"
				}
			}
		},
		required: [
			"data"
		],
		additionalProperties: false
	},
	RestBot: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			clientId: {
				type: [
					"string",
					"null"
				]
			}
		},
		required: [
			"id",
			"clientId"
		],
		additionalProperties: false
	},
	MongoChannel: {
		type: "object",
		properties: {
			_id: {
				type: "string"
			},
			bot_id: {
				type: "string"
			}
		},
		required: [
			"_id",
			"bot_id"
		],
		additionalProperties: false
	},
	RestBillingInfos: {
		type: "object",
		properties: {
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			portalUrl: {
				type: "string"
			},
			billingId: {
				$ref: "#/definitions/BillingId"
			}
		},
		required: [
			"clientId",
			"portalUrl",
			"billingId"
		],
		additionalProperties: false
	},
	RestClientBots: {
		type: "object",
		properties: {
			clientId: {
				$ref: "#/definitions/ClientId"
			},
			bots: {
				type: "array",
				items: {
					type: "string"
				}
			}
		},
		required: [
			"clientId",
			"bots"
		],
		additionalProperties: false
	},
	PgConversation: {
		type: "object",
		properties: {
			conversation_id: {
				type: "string"
			},
			user_id: {
				type: "string"
			},
			channel_id: {
				type: "string"
			},
			active_interlocutor: {
				type: "string",
				"enum": [
					"Agent",
					"Bot"
				]
			},
			creation_date: {
				type: "string"
			}
		},
		required: [
			"conversation_id",
			"user_id",
			"channel_id",
			"active_interlocutor",
			"creation_date"
		],
		additionalProperties: false
	},
	PgUser: {
		type: "object",
		properties: {
			user_id: {
				type: "string"
			},
			client_id: {
				type: "string"
			}
		},
		required: [
			"user_id",
			"client_id"
		],
		additionalProperties: false
	},
	PgClient: {
		type: "object",
		properties: {
			client_id: {
				type: "string"
			}
		},
		required: [
			"client_id"
		],
		additionalProperties: false
	},
	PgUsageRecord: {
		type: "object",
		properties: {
			usage_record_id: {
				type: "string"
			},
			bot_id: {
				type: "string"
			},
			channel_id: {
				type: "string"
			},
			nb_record: {
				type: "number"
			},
			client_id: {
				type: "string"
			},
			create_date: {
				type: "string"
			},
			status: {
				type: "string",
				"enum": [
					"sent",
					"error"
				]
			},
			type: {
				type: "string",
				"enum": [
					"stripe",
					"other"
				]
			}
		},
		required: [
			"usage_record_id",
			"bot_id",
			"channel_id",
			"nb_record",
			"client_id",
			"create_date",
			"status",
			"type"
		],
		additionalProperties: false
	},
	PgDayConversationCount: {
		type: "object",
		properties: {
			creation_date: {
				type: "string"
			},
			count: {
				type: "string"
			}
		},
		required: [
			"creation_date",
			"count"
		],
		additionalProperties: false
	},
	PgBotConversationCount: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			nb: {
				type: "number"
			}
		},
		required: [
			"bot_id",
			"nb"
		],
		additionalProperties: false
	},
	PgChannelConversationCount: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			channel_id: {
				type: "string"
			},
			nb: {
				type: "number"
			}
		},
		required: [
			"bot_id",
			"channel_id",
			"nb"
		],
		additionalProperties: false
	},
	PgBotsConversationCount: {
		type: "array",
		items: {
			$ref: "#/definitions/PgBotConversationCount"
		}
	},
	PgChannelsConversationCount: {
		type: "array",
		items: {
			$ref: "#/definitions/PgChannelConversationCount"
		}
	},
	ConversationCountWithCompanyId: {
		type: "object",
		properties: {
			startDate: {
				type: "string",
				format: "date-time"
			},
			endDate: {
				type: "string",
				format: "date-time"
			},
			companyId: {
				type: "string"
			},
			count: {
				type: "number"
			}
		},
		required: [
			"startDate",
			"endDate",
			"companyId",
			"count"
		],
		additionalProperties: false
	},
	CustomData: {
		type: "object",
		properties: {
			companyId: {
				type: "string"
			},
			customDataId: {
				type: "string"
			}
		},
		required: [
			"companyId",
			"customDataId"
		],
		additionalProperties: false
	},
	CompanyIdQueryResultResults: {
		type: "object",
		properties: {
			id: {
				type: "string"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	CompanyIdQueryResult: {
		type: "object",
		properties: {
			total: {
				type: "number"
			},
			results: {
				type: "array",
				items: {
					$ref: "#/definitions/CompanyIdQueryResultResults"
				}
			}
		},
		required: [
			"total",
			"results"
		],
		additionalProperties: false
	},
	CustomDataQueryResult: {
		type: "object",
		properties: {
			id: {
				type: "string"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  $schema: $schema,
  definitions: definitions,
  'default': entitiesSchemas
});

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null
});

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null
});

const usageRecordFactory = (botId, channelId, nbRecord, clientId, type, status, date) => ({
  botId,
  channelId,
  clientId,
  date: date !== null && date !== void 0 ? date : new Date(),
  id: genericUtils.generateUniqueId(),
  nbRecord,
  status,
  type
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  usageRecordFactory: usageRecordFactory
});

var applicationPorts = /*#__PURE__*/Object.freeze({
  __proto__: null
});

/* eslint-disable max-lines */

const uniqueChannelIdFromChannels = channels => channels.map(channel => {
  return channel.id;
}).filter((value, index, array) => array.indexOf(value) === index);

const uniqueBotIdFromChannelsConversationCount = channelsBotConversationCount => channelsBotConversationCount.map(channelsBotConversationCount => {
  return channelsBotConversationCount.botId;
}).filter((value, index, array) => array.indexOf(value) === index);

const uniqueClientIdFromBots = bots => bots.map(bot => {
  return bot.clientId;
}).filter(clientId => clientId !== null).filter((value, index, array) => array.indexOf(value) === index);

const getBotsFromChannelsConversationCount = getBotByBotId => async channelsBotConversationCount => {
  const uniquebotId = uniqueBotIdFromChannelsConversationCount(channelsBotConversationCount);
  const bots = await Promise.all(uniquebotId.map(async botId => {
    const bot = await getBotByBotId(botId);
    return bot;
  }));
  return bots.filter(bot => {
    return genericUtils.isObject(bot);
  });
};

const getBillingInfosFromBot = getOneBillingInfosByClientId => async bots => {
  const clientsId = uniqueClientIdFromBots(bots);
  const allBillinginfosAxios = await Promise.all(clientsId.map(async clientId => {
    const result = await getOneBillingInfosByClientId(clientId);
    return result;
  }));
  return allBillinginfosAxios.filter(billingInfo => genericUtils.isObject(billingInfo));
};

const getItemsSubscriptionMeteredFromBillingsInfos = getOneItemSubscriptionMeteredByBillingInfo => async billingsInfos => {
  const itemSubscriptionMetered = await Promise.all(billingsInfos.map(async billingInfo => {
    const result = await getOneItemSubscriptionMeteredByBillingInfo(billingInfo);
    return result;
  }));
  return itemSubscriptionMetered.filter(itemSubscriptionMetered => itemSubscriptionMetered !== null);
};

const conversationbyClientBotChannel = (channelsBotConversationCount, bots) => {
  const mapClientIdBybotId = bots.reduce((accumulateur, valeurCourante) => {
    const clientIdByBotId = accumulateur.get(valeurCourante.id);

    if (typeof clientIdByBotId === 'undefined' && valeurCourante.clientId !== null) {
      accumulateur.set(valeurCourante.id, valeurCourante.clientId);
    }

    return accumulateur;
  }, new Map());
  return channelsBotConversationCount.map(channelsBotConversationCount => {
    const clientId = mapClientIdBybotId.get(channelsBotConversationCount.botId);

    if (typeof clientId !== 'undefined') {
      return {
        botId: channelsBotConversationCount.botId,
        channelId: channelsBotConversationCount.id,
        clientId,
        count: channelsBotConversationCount.count
      };
    }

    return null;
  }).filter(item => genericUtils.isObject(item));
};

const clientBotChannelAnyBillingInfo = (billingsInfos, clientBotChannels) => {
  const billingInfosClient = new Set(billingsInfos.map(billingInfos => billingInfos.clientId));
  return clientBotChannels.map(clientBotChannel => {
    if (billingInfosClient.has(clientBotChannel.clientId)) {
      return {};
    }

    return Object.assign({}, clientBotChannel);
  }).filter(clientBotChannel => !genericUtils.isEmpty(clientBotChannel));
};

const clientBotChannelBilling = (billingsInfos, clientBotChannels) => {
  const mapBillingIdByClientId = billingsInfos.reduce((accumulateur, valeurCourante) => {
    const billingId = accumulateur.get(valeurCourante.clientId);

    if (typeof billingId === 'undefined') {
      accumulateur.set(valeurCourante.clientId, valeurCourante.billingId);
    }

    return accumulateur;
  }, new Map());
  return clientBotChannels.map(clientBotChannel => {
    const billingId = mapBillingIdByClientId.get(clientBotChannel.clientId);

    if (typeof billingId !== 'undefined') {
      return Object.assign(Object.assign({}, clientBotChannel), {
        billingId
      });
    }

    return {};
  }).filter(clientBotChannelBilling => !genericUtils.isEmpty(clientBotChannelBilling));
};

const clientBotChannelBillingItemSubscription = (itemsSubscriptionMetered, clientBotChannelBilling) => {
  const mapItemsSubscriptionMeteredByBillingId = itemsSubscriptionMetered.reduce((accumulateur, valeurCourante) => {
    const itemsSubscriptionMeteredMap = accumulateur.get(valeurCourante.billingId);

    if (typeof itemsSubscriptionMeteredMap === 'undefined') {
      accumulateur.set(valeurCourante.billingId, valeurCourante.itemSubscriptionId);
    }

    return accumulateur;
  }, new Map());
  return clientBotChannelBilling.map(clientBotChannelBilling => {
    if (mapItemsSubscriptionMeteredByBillingId.has(clientBotChannelBilling.billingId)) {
      const itemSubscriptionId = mapItemsSubscriptionMeteredByBillingId.get(clientBotChannelBilling.billingId);

      if (typeof itemSubscriptionId !== 'undefined') {
        return Object.assign(Object.assign({}, clientBotChannelBilling), {
          itemSubscriptionMeteredId: itemSubscriptionId
        });
      }
    }

    return {};
  }).filter(clientBotChannelBillingSubcscription => !genericUtils.isEmpty(clientBotChannelBillingSubcscription));
};

const convertManyClientBotChannelBillingSubscriptionCountToManyClientStripeConversationsCount = clientBotChannelBillingSubscriptionConversationsCount => {
  const map = clientBotChannelBillingSubscriptionConversationsCount.reduce((accumulator, valeurCourante) => {
    const infosByClientId = accumulator.get(valeurCourante.clientId);

    if (typeof infosByClientId === 'undefined') {
      accumulator.set(valeurCourante.clientId, {
        billingId: valeurCourante.billingId,
        clientId: valeurCourante.clientId,
        count: valeurCourante.count,
        details: [{
          botId: valeurCourante.botId,
          channelId: valeurCourante.channelId,
          count: valeurCourante.count
        }],
        itemSubscriptionMeteredId: valeurCourante.itemSubscriptionMeteredId
      });
      return accumulator;
    }

    accumulator.set(valeurCourante.clientId, Object.assign(Object.assign({}, infosByClientId), {
      count: infosByClientId.count + valeurCourante.count,
      details: [...infosByClientId.details, {
        botId: valeurCourante.botId,
        channelId: valeurCourante.channelId,
        count: valeurCourante.count
      }]
    }));
    return accumulator;
  }, new Map());
  return [...map.values()];
};

const sendManyConversationCount = sendOneConversationsCount => async (clientBotChannelClientsAnyBillingInfo, endDate) => {
  await Promise.all(clientBotChannelClientsAnyBillingInfo.map(async clientBotChannelClient => sendOneConversationsCount(clientBotChannelClient, endDate)));
};

const sendManyConversationCountStripe = sendOneConversationsCountStripe => async (manyClientStripeConversationsCount, endDate) => {
  await Promise.all(manyClientStripeConversationsCount.map(async clientStripeConversationsCount => sendOneConversationsCountStripe(clientStripeConversationsCount, endDate)));
};

/* eslint-disable max-lines-per-function */

const getOneClientConversationsCount = (getOneClientBotsByClientId, getManyChannelByBotIds, getManyConversationsByManyChannelIdAndPeriod) => async (startDate, endDate, clientId) => {
  const clientBots = await getOneClientBotsByClientId(clientId);

  if (clientBots === null) {
    return {
      clientId,
      count: genericUtils.NUMBER.DEFAULT_CONVERSATION,
      endDate,
      startDate
    };
  }

  const channels = await getManyChannelByBotIds(clientBots.bots);

  if (genericUtils.isEmpty(channels)) {
    return {
      clientId,
      count: 0,
      endDate,
      startDate
    };
  }

  const conversations = await getManyConversationsByManyChannelIdAndPeriod(startDate, endDate, uniqueChannelIdFromChannels(channels));
  return {
    clientId,
    count: conversations.length,
    endDate,
    startDate
  };
};

const sendAllConversationCount = (getManyConversationsByPeriod, getBotByBotId, getOneBillingInfosByClientId, getOneItemSubscriptionMeteredByBillingInfo, sendOneConversationsCountStripe, sendOneConversationsCount) => async (startDate, endDate) => {
  const channelsConversationCount = await getManyConversationsByPeriod(startDate, endDate);
  const bots = await getBotsFromChannelsConversationCount(getBotByBotId)(channelsConversationCount);
  const billingsinfos = await getBillingInfosFromBot(getOneBillingInfosByClientId)(bots);
  const itemsSubscriptionMetered = await getItemsSubscriptionMeteredFromBillingsInfos(getOneItemSubscriptionMeteredByBillingInfo)(billingsinfos);
  const conversationbyClientBotChannel$1 = conversationbyClientBotChannel(channelsConversationCount, bots);
  const clientBotChannelClientsAnyBillingInfo = clientBotChannelAnyBillingInfo(billingsinfos, conversationbyClientBotChannel$1);
  await sendManyConversationCount(sendOneConversationsCount)(clientBotChannelClientsAnyBillingInfo, endDate);
  const clientBotChannelBilling$1 = clientBotChannelBilling(billingsinfos, conversationbyClientBotChannel$1);
  const clientBotChannelBillingItemSubscriptions = clientBotChannelBillingItemSubscription(itemsSubscriptionMetered, clientBotChannelBilling$1);
  const manyClientStripeConversationsCount = convertManyClientBotChannelBillingSubscriptionCountToManyClientStripeConversationsCount(clientBotChannelBillingItemSubscriptions);
  await sendManyConversationCountStripe(sendOneConversationsCountStripe)(manyClientStripeConversationsCount, endDate);
};

const getOneChannelDetailConversationsCount = getManyDaysConversationCount => async (startDate, endDate, channelId) => {
  const detailCount = await getManyDaysConversationCount(startDate, endDate, channelId);
  const totalCount = detailCount.reduce((accumulateur, valeurCourante) => {
    return accumulateur + valeurCourante.count;
  }, genericUtils.NUMBER.DEFAULT_CONVERSATION);
  return {
    channelId,
    detailCount,
    endDate: new Date(endDate),
    startDate: new Date(startDate),
    totalCount
  };
};

const getOneBotConversationsCount = (getManyChannelsByBotId, getManyConversationsByManyChannelIdAndPeriod) => async (startDate, endDate, botId) => {
  const channels = await getManyChannelsByBotId(botId);

  if (genericUtils.isEmpty(channels)) {
    return {
      botId,
      count: 0,
      endDate,
      startDate
    };
  }

  const conversations = await getManyConversationsByManyChannelIdAndPeriod(startDate, endDate, uniqueChannelIdFromChannels(channels));
  return {
    botId,
    count: conversations.length,
    endDate,
    startDate
  };
};

const getOneBotDetailConversationCount = getManyBotDaysConversationCountbyBotId => async (startDate, endDate, botId) => {
  const detailCount = await getManyBotDaysConversationCountbyBotId(startDate, endDate, botId);
  const totalCount = detailCount.reduce((accumulateur, valeurCourante) => {
    return accumulateur + valeurCourante.count;
  }, genericUtils.NUMBER.ZERO);
  return {
    botId,
    detailCount,
    endDate: new Date(endDate),
    startDate: new Date(startDate),
    totalCount
  };
};

const saveConversationCountOfPreviousDay = (getAllClientBots, getManyConversationCountByPeriodAndClientsBots, saveManyConversationCount) => async () => {
  const yesterdayPeriod = genericUtils.getOnePeriod('yesterday');
  const clientsBots = await getAllClientBots();
  const conversationCount = await getManyConversationCountByPeriodAndClientsBots(yesterdayPeriod.startDate, yesterdayPeriod.endDate, clientsBots);
  await saveManyConversationCount(conversationCount);
};

export { applicationPorts as appPorts, index$2 as botModel, index$9 as botsRepositoryAxios, index$8 as channelsRepositoryMongodb, index$1 as clientModel, index$7 as clientsRepositoryAxios, index$b as conversationsAxios, index$6 as conversationsRepositoryPostgresql, index$5 as conversationsRepositoryPostgresqlAxios, index$4 as conversationsRepositoryPostgresqlMongo, entitiesSchemas$1 as entitiesSchemas, getOneBotConversationsCount, getOneBotDetailConversationCount, getOneChannelDetailConversationsCount, getOneClientConversationsCount, index$3 as hubspotServiceAxios, saveConversationCountOfPreviousDay, sendAllConversationCount, index$a as stripeServiceBilling, index as usageRecordModel };
